export default __webpack_public_path__ + "static/media/cont1.d17a0c67.jpg";